<template>
  <el-dialog
    title="修改编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="80px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="editData"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
// import {brequest} from '@/utils/brequest'
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    editData: Object,
    deviceTypeList: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '姓名',
          field: 'name',
          type: 'text',
          // disabled: true,

          rules: [{ required: true, message: '姓名必填', trigger: 'blur' }]
        },
        {
          label: '手机号',
          field: 'phone',
          type: 'text',
          rules: [
            { required: true, message: '手机号必填', trigger: 'blur' },
            {
              validator: this.checkMobilePhone,
              trigger: 'blur'
            }
          ]
        },
        {
          label: '公司名称',
          field: 'companyName',
          type: 'text',
          clearable: true,
          rules: [{ required: true, message: '用户姓名必填', trigger: 'blur' }]
        },
        {
          label: '设备类型',
          field: 'deviceType',
          multiple: true,
          type: 'select',
          payload: this.deviceTypeList,
          rules: [{ required: true, message: '设备类型必填', trigger: 'blur' }]
        }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },

  methods: {
    checkMobilePhone(rule, value, callback) {
      if (!/^1[345789]\d{9}$/.test(value)) return callback('手机号格式有误')

      return callback()
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      // console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
